import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';
import { isNotEmptyArray, isNotEmptyString } from '../utils/validators';

export default class FieldsApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  // =============================================================================
  //                            Fields APIS
  // =============================================================================

  public FieldMetaDataTypesList(queries: any = {}) {
    const query = `/core/v3/fieldsmetadata/types${qs.stringify(queries, true)}`;
    return this.get(query);
  }

  public FieldMetaDataList(queries: any = {}) {
    const query = '/core/v3/fieldsmetadata';

    let parameters = '?alk=1';
    if (queries.links) {
      parameters += '&links=1';
    }
    if (queries.rootId) {
      parameters += `&root_id=${queries.rootId}`;
    }
    if (queries.fieldIds) {
      parameters += `&field_ids=${queries.fieldIds}`;
    }
    return this.get(query, parameters);
  }

  public FieldMetaDataRoots() {
    const query = '/core/v3/fieldsmetadata/roots';
    return this.get(query);
  }

  public FieldMetaDataCreate(field: any) {
    const query = '/core/v3/fieldsmetadata';
    return this.post(query, field);
  }

  public FieldMetaDataUpdate(field: any) {
    const query = `/core/v3/fieldsmetadata/${field.id}`;
    return this.put(query, field);
  }

  public getDocumentation(queries: any, fieldRoot: string | null = null) {
    let url = '/core/v3/fieldsmetadata/documentation';
    if (fieldRoot) {
      url = `/core/v3/fieldsmetadata/documentation/${fieldRoot}`;
    }
    const query = `${url}${qs.stringify(queries, true)}`;
    return this.get(query);
  }

  public downloadSample(queries: any) {
    const query = `/core/v3/fieldsmetadata/sample/download${qs.stringify(
      queries,
      true,
    )}`;
    return this.getBlob(query);
  }

  public listMainFields(
    search?: string,
    attributes?: any,
    entityType?: string,
    queries: any = {},
  ) {
    const params: any = queries;
    if (isNotEmptyString(search)) {
      params.search = search;
    }
    if (isNotEmptyArray(attributes)) {
      params.attributes = attributes.join(',');
    }
    if (isNotEmptyString(entityType)) {
      params.entity_type = entityType;
    }
    if (queries.withSpecific) {
      params.with_specific = queries.withSpecific;
    }
    const query = `/core/v3/fieldsmetadata/main${qs.stringify(params, true)}`;
    return this.get(query);
  }

  public getLabels(queries: any = {}) {
    return this.get(
      `/core/v3/fieldsmetadata/labels${qs.stringify(queries, true)}`,
    );
  }

  public getField(fieldId: number) {
    return this.get(`/core/v3/fieldsmetadata/${fieldId}`);
  }

  public deleteField(fieldId: number) {
    return this.delete(`/core/v3/fieldsmetadata/${fieldId}`);
  }

  public refreshCache() {
    return this.get('/core/v3/metadatacache/refresh');
  }
}
